export const diamention = {
  navbarHeight    : 120,
  drawerWidth    : 340,

}